import {
  PayloadAction,
  createEntityAdapter,
  createSlice,
} from '@reduxjs/toolkit';

import { LoadingStates } from '@tdp/common/constants';

import { AppPackageEditorStatus } from '../abstractions/EPackageEditor';
import { IAppPackageEditor, IAppPackageEditorFile } from '../abstractions/IPackageEditor';

const initialState: IAppPackageEditor = {
  appId: null,
  status: AppPackageEditorStatus.NotLoaded,
  initFiles: [],
  localFiles: [],
  activeMonacoSchema: {},
}

export const packageEditorSlice = createSlice({
  name: "packageEditor",
  initialState,
  reducers: {
    reset: (state) => {
      state.status = AppPackageEditorStatus.NotLoaded;
      state.appId = null;
    },
    setAppId: (state, action: PayloadAction<string>) => {
      state.appId = action.payload;
    },
    discardLocalFiles: (state) => {
      state.status = AppPackageEditorStatus.NoChanges;
      state.localFiles = state.initFiles;
    },
    setInitialPackageFiles: (state, action: PayloadAction<IAppPackageEditorFile[]>) => {
      state.status = AppPackageEditorStatus.NoChanges;
      state.initFiles = action.payload;
      state.localFiles = action.payload;
    },
    appPackageEditorStatusChange: (state, action: PayloadAction<AppPackageEditorStatus>) => {
      state.status = action.payload;
    },
    appPackageEditorUpdateLocalFile: (state, action: PayloadAction<IAppPackageEditorFile>) => {
      state.localFiles = state.localFiles.map((file) => {
        if (file.id === action.payload.id) {
          return action.payload;
        }
        return file;
      });
    },
    appPackageEditorAddLocalFile: (state, action: PayloadAction<IAppPackageEditorFile>) => {
      state.localFiles.push(action.payload);
    },
    appPackageEditorRemoveLocalFileById: (state, action: PayloadAction<string>) => {
      state.localFiles = state.localFiles.filter((file) => file.id !== action.payload);
    },
    addMonacoSchema: (state, action: PayloadAction<{ key: string; schema: unknown }>) => {
      const { key, schema } = action.payload;
      state.activeMonacoSchema[key] = schema;
    }
  },
  selectors: {
    appId: (s) => s.appId,
    status: (s) => s.status,
    localFiles: (s) => s.localFiles,
    initFiles: (s) => s.initFiles,
    getMonacoSchema: (s) => s.activeMonacoSchema
  }
});
